// Import non-SVG files explicitly
import '../images/loading_icon.gif';
import '../images/login-page.jpg';
import '../images/podcast-placeholder.webp'
import '../images/podcast-placeholder.png'
import '../images/hadran-symbol.png'
import '../images/login-bg.jpg'
import '../images/new-user-popup-img.png'

// Import all SVG files recursively from the images directory and its subdirectories
const imagesContext = require.context('../images', true, /\.svg$/i);
imagesContext.keys().forEach(imagesContext);
